export default __webpack_public_path__ + "static/media/tracker-icon.a7ca009a.png";